import { X } from "lucide-react";
import { DimensionsListTitle } from "./_DimensionsListTitle";
import { DimensionsFormTitle } from "./_DimensionsFormTitle";

type TView = "list" | "add" | "edit";

type TProps = {
  view: TView;
  isPending: boolean;
  onBack: () => void;
  onClose: () => void;
};

export function ManageDimensionsHeader(props: TProps) {
  const { view, isPending, onBack, onClose } = props;

  return (
    <div className="flex items-center justify-between gap-5 border-b border-[#f4f4f5] bg-white p-5">
      {view === "list" ? (
        <DimensionsListTitle />
      ) : (
        <DimensionsFormTitle view={view} disabled={isPending} onBack={onBack} />
      )}
      <button
        type="button"
        className="flex items-center justify-center text-zinc-400 hover:text-zinc-700 disabled:opacity-50"
        onClick={onClose}
        disabled={isPending}
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  );
}
